import React from "react";
import { connect } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import PropTypes from "prop-types";
import { logout } from "../../actions/Auth";

const SideNavBar = ({ restaurant }) => {
  const isDisabledLink = !restaurant || !restaurant.id;
  const location = useLocation();
  const currentLocation = location.pathname;

  return (
    <Nav variant="pills" className="flex-column wrapper side-bar">
      <Nav.Item>
        <Nav.Link
          as={NavLink}
          to="/restaurant-setting"
          disabled={currentLocation.includes("/restaurant-setting")}
        >
          Restaurant Settings
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          as={NavLink}
          to="/menus-list"
          disabled={isDisabledLink || currentLocation.includes("/menus-list")}
        >
          Menu(s)
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          as={NavLink}
          to="/qr-code"
          disabled={isDisabledLink || currentLocation.includes("/qr-code")}
        >
          QR Code &amp; Menu Link
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          as={NavLink}
          to="/users"
          disabled={isDisabledLink || currentLocation.includes("/users")}
        >
          Manage Users
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <hr></hr>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link as={NavLink} to="/logout" className="side-bar-link">
          Log out
        </Nav.Link>
      </Nav.Item>
    </Nav>
  );
};

SideNavBar.propTypes = {
  restaurant: PropTypes.object,
  logout: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  restaurant: state.restaurant.restaurant,
});

export default connect(mapStateToProps, { logout })(SideNavBar);
